<template>
  <div class="el-tabs-container">
    <el-tabs v-model="tab_index">
      <el-tab-pane label="SEI物料">
        <span slot="label">{{$t("tab.tab_sei_invent")}}</span>
        <InventTableSEI></InventTableSEI>
      </el-tab-pane>
      <el-tab-pane label="物料">
        <span slot="label">{{$t("tab.tab_invent")}}</span>
        <InventTable></InventTable>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import InventTableSEI from "./InventTableSEI";
import InventTable from "./InventTable";

export default {
  name: "InventTableMain",
  components: {
    InventTableSEI,
    InventTable
  },
  data() {
    return {
      tab_index: 0
    };
  },
  created() { },
  methods: {}
};
</script>
